export default "__VITE_ASSET__a1864fae__"